import React from 'react';
import Form, { Actions, EmailAddressValidator, RequiredValidator, TextField } from '../../../Components/Form';

const EmailChallenge = ({ email, onSubmit }) => {
    return <Form data={{email}} onSubmit={onSubmit}>
        <TextField
            type="email"
            name="email"
            label="Email"
            validators={[RequiredValidator, EmailAddressValidator]}
        />
        <Actions submit={{label: 'Continue'}} />
    </Form>;
};

export default EmailChallenge;
